<template>
  <gg-card>
    <gg-card-header>Add New Subdomain</gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <gg-text-field v-model="model.domain"
                         label="Subdomain name"
                         placeholder="Enter a new subdomain"
                         name="Subdomain name"
                         v-validate="'required'"
                         :error-messages="errors.collect('Subdomain name')"
          >
            <template v-slot:append>
              <div class="append-bg">
                <domain-select v-model="model.rootdomain"
                               name="Root Domain"
                               no-label
                               hide-details
                               solo
                               flat
                               :error-messages="errors.collect('Root Domain')"
                               :remote_domain="model.rootdomain"
                />
              </div>
            </template>
          </gg-text-field>
        </v-col>
      </v-row>
<!--        <v-text-field outlined-->
<!--                      v-model="model.domain"-->
<!--                      label="Subdomain name"-->
<!--                      name="Subdomain name"-->
<!--                      placeholder="Enter a new subdomain"-->
<!--                      v-validate="'required'"-->
<!--                      :error-messages="errors.collect('Subdomain name')"></v-text-field>-->
<!--        <domain-select v-model="model.rootdomain"-->
<!--                       name="Root Domain"-->
<!--                       :error-messages="errors.collect('Root Domain')"-->
<!--                       :remote_domain="model.rootdomain"-->
<!--                       no-label></domain-select>-->
<!--        <autocomplete-dir v-model="dir"-->
<!--                          v-validate="'required'"-->
<!--                          label="Subdomain directory"-->
<!--                          name="Subdomain directory"-->
<!--                          :error-messages="errors.collect('Subdomain directory')"></autocomplete-dir>-->
      <gg-btn primary :loading="button.loading" @click="addSubdomain">Create Subdomain</gg-btn>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions } from 'vuex'
import amapi from 'Api/amapi'
import DomainSelect from '@/components/Common/DomainSelect'

export default {
  name: 'AddSubdomainForm',
  components: {
    DomainSelect,
  },
  data () {
    return {
      model: {
        domain: '',
        rootdomain: ''
      },
      dir: '',
      button: {
        loading: false
      }
    }
  },
  methods: {
    ...mapActions({
      getHostingSubdomains: 'hostingDomains/getHostingSubdomains',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    clearData () {
      this.model.domain = ''
      this.dir = ''
    },
    clearValidator () {
      this.$validator.reset()
    },
    async addSubdomain () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }

      this.button.loading = true

      let data = {
        api2_module: 'SubDomain',
        api2_method: 'addsubdomain',
        domain: this.model.domain,
        rootdomain: this.model.rootdomain,
        dir: this.dir,
        _username: this.$route.query.user,
      }

      try {
        let response = await amapi.cpanel_api2({ ...data })
        response.data.forEach(item => {
          if (item.result) {
            this.reportSuccess(item.reason)
            this.$emit('subdomain-added')
          } else {
            this.reportError(item.reason)
          }
        })

        this.clearData()
        this.clearValidator()

        this.button.loading = false
      } catch (e) {
        this.button.loading = false

        this.reportError(e)
      }
    }
  },
  watch: {
    model: {
      handler () {
        this.dir = `${this.model.domain}.${this.model.rootdomain}`
      },
      deep: true
    }
  }
}
</script>
